import styled from 'styled-components'
import Img from 'gatsby-image'
import { BORDER } from 'styles/tokens'

const Image = styled(Img)`
  border-radius: ${BORDER.RADIUS.S};
`

export default Image
